import { Component, Input, OnInit } from 'ng-metadata/core';
import * as angular from 'angular';
import './web.scss';

/**
 * @ngdoc directive
 * @name mwMediaSourceDocumentWeb
 * @module mw.components.contentDocuments
 *
 * @param {string} [url] - Web url
 *
 * @description
 * `<mw-media-source-document-web>` is a component used to show the web of the source
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 *
 */
const template = `
    <a class="mw-media-source-document-web"
        ng-href="{{::$ctrl.url}}"
        ng-bind-html="::$ctrl.name">
    </a>`;


@Component({
    selector: 'mw-media-source-document-web',
    template: template
})

export class MediaSourceDocumentWebComponent implements OnInit{
    @Input('<') url: string;

    private name: string;

    constructor() {}

    ngOnInit() {
        this.name = this.url.replace(/^(?:http?:\/\/)?(?:https?:\/\/)?/i, '');
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/web/web.component.ts